module.exports = __webpack_public_path__ + "static/media/like.542059a4.svg";